import { Box, Divider, List, ListItem, ListItemText, Typography } from '@mui/material';
import React from 'react';
import { useTypedSelector } from '../../../../store/hooks';
import langFile from '../../../../data/lang.json';

const CreditCalculationData: React.FC = (props) => {
    const { amount, annuity, differentiated, type } = useTypedSelector((state) => state.loans);
    const { lang } = useTypedSelector((state) => state.common);
    const format = lang === 'kz' ? 'ru' : lang;

    return (
        <Box>
            <List
                dense
                subheader={
                    <Typography sx={{ textAlign: 'center' }}>
                        {
                            (type === 0
                                ? langFile.paymentTypes.annuity
                                : (langFile.paymentTypes.differentiated as any))[lang]
                        }
                    </Typography>
                }
            >
                <ListItem secondaryAction={<Typography>{amount.toLocaleString(format)}</Typography>}>
                    <ListItemText primary={(langFile.loanAmount as any)[lang]} />
                </ListItem>
                <Divider />
                <ListItem
                    secondaryAction={
                        <Typography>
                            {Math.round(
                                type === 0 ? annuity.totalAmount : differentiated.totalAmount,
                            ).toLocaleString(format)}
                        </Typography>
                    }
                >
                    <ListItemText primary={(langFile.totalPaymentsAmount as any)[lang]} />
                </ListItem>
                <Divider />
                <ListItem
                    secondaryAction={
                        <Typography>
                            {Math.round(
                                type === 0 ? annuity.overPayment : differentiated.overPayment,
                            ).toLocaleString(format)}
                        </Typography>
                    }
                >
                    <ListItemText
                        primary={(langFile.loanTotalAmount as any)[lang]}
                        secondary={(langFile.overpaymentForPeriod as any)[lang]}
                    />
                </ListItem>
                <Divider />
                <ListItem
                    secondaryAction={
                        <Typography>
                            {Math.round(
                                type === 0 ? annuity.monthlyPayment : differentiated.monthlyPayment,
                            ).toLocaleString(format)}
                        </Typography>
                    }
                >
                    <ListItemText primary={(langFile.monthlyPayment as any)[lang]} />
                </ListItem>
            </List>
            {/* <List 
                dense
                subheader={<Typography sx={{ textAlign: 'center' }}>{(langFile.paymentTypes.differentiated as any)[lang]}</Typography>}>
                <ListItem
                    secondaryAction={
                        <Typography>{amount.toLocaleString(format)}</Typography>
                    }>
                    <ListItemText
                        primary={(langFile.loanAmount as any)[lang]}
                    />
                </ListItem>
                <Divider />
                <ListItem
                    secondaryAction={
                        <Typography>{differentiated.totalAmount.toLocaleString(format)}</Typography>
                    }>
                    <ListItemText
                        primary={(langFile.totalPaymentsAmount as any)[lang]}
                    />
                </ListItem>
                <Divider />
                <ListItem
                    secondaryAction={
                        <Typography>{differentiated.overPayment.toLocaleString(format)}</Typography>
                    }>
                    <ListItemText
                        primary={(langFile.loanTotalAmount as any)[lang]}
                    />
                </ListItem>
                <Divider />
                <ListItem
                    secondaryAction={
                        <Typography>{differentiated.monthlyPayment.toLocaleString(format)}</Typography>
                    }>
                    <ListItemText
                        primary={(langFile.monthlyPayment as any)[lang]}
                    />
                </ListItem>
            </List> */}
        </Box>
    );
};

export default CreditCalculationData;
